import { reportMetrics } from './reportMetrics'
import { pageError } from './metrics/creates'
import { getRoute } from './route'

const TAG = '@shopeepay/reporter'

function getDevice() {
  if (typeof window === 'undefined') return 'unknown'
  return window.innerWidth >= 768 ? 'pc' : 'mobile'
}

function getUaToken() {
  if (typeof navigator === 'undefined' || !navigator.userAgent) return 'unknown'
  return navigator.userAgent.split(' ').pop() || 'unknown'
}

export function reportJsError(errorMessage, route) {
  if (typeof window === 'undefined') return
  reportMetrics(
    pageError({
      error_message: String(errorMessage).substring(0, 200),
      route,
      device: getDevice(),
      ext1: getUaToken()
    })
  )
}

export function initErrorTracking(maxErrorsPerSession = 50) {
  if (typeof window === 'undefined') return

  let errorCount = 0

  window.addEventListener('error', (event) => {
    if (errorCount >= maxErrorsPerSession) return
    const msg = event.message || ''
    if (msg.includes(TAG) || msg.includes('telemetry')) return
    errorCount++
    reportJsError(msg || 'Unknown error', getRoute())
  })

  window.addEventListener('unhandledrejection', (event) => {
    if (errorCount >= maxErrorsPerSession) return
    const msg = String(event.reason) || ''
    if (msg.includes(TAG) || msg.includes('telemetry')) return
    errorCount++
    reportJsError(msg || 'Unhandled promise rejection', getRoute())
  })
}
